var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTophostHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9675 107.997L60 101.822L43.0325 107.997L34.005 92.36L17.0375 86.185L20.1725 68.4025L11.145 52.765L24.9775 41.1575L28.1125 23.375H46.17L60.0025 11.7675L73.835 23.375H91.8925L95.0275 41.1575L108.86 52.765L99.8325 68.4025L102.968 86.185L86 92.36L76.9725 107.997H76.9675ZM60 95.4375L74.29 100.637L81.8925 87.4675L96.1825 82.2675L93.5425 67.2925L101.145 54.1225L89.4975 44.3475L86.8575 29.3725H71.6525L60.005 19.5975L48.3575 29.3725H33.1525L30.5125 44.3475L18.865 54.1225L26.4675 67.2925L23.8275 82.2675L38.1175 87.4675L45.72 100.637L60.01 95.4375H60Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTophostHighlight);
export default __webpack_public_path__ + "static/media/Tophost_Highlight.aa29dacc.svg";
export { ForwardRef as ReactComponent };